import { ToastContainer } from "../../components/Common";
import UserProfile from "./components/user-profile";
import HeaderBox from "./components/header-box";

const UserProfileWrapper = () => {
    //meta title
    document.title = "Profile";

    return (
        <div className="page-content">
            <HeaderBox />
            <UserProfile />
            <ToastContainer/>
        </div>
    );
};

export default UserProfileWrapper;
